import styles from './SimpleListItem.module.scss';
import { type ReactNode } from 'react';

interface Props {
  addonEnd?: ReactNode;
  addonStart?: ReactNode;
  children: ReactNode;
  marker?: ReactNode;
}

export function SimpleListItem({
  addonEnd,
  addonStart,
  children,
  marker,
}: Props) {
  const className = [
    styles['simple-list-item'],
    marker && styles['with-marker'],
  ]
    .filter(Boolean)
    .join(' ');
  const contentClassName = [styles['content']].filter(Boolean).join(' ');

  return (
    <li className={className}>
      {marker && <div>{marker}</div>}
      <div className={contentClassName}>
        {addonStart && <div>{addonStart}</div>}
        <div className={styles['children']}>{children}</div>
        {addonEnd && <div>{addonEnd}</div>}
      </div>
    </li>
  );
}
